      (function () {
  if (window.__anchorNavReady) return;
  window.__anchorNavReady = true;

  function init(root) {
    if (!root || root.dataset.anavInitialized === 'true') return;
    root.dataset.anavInitialized = 'true';

        const extraOffset = Number(root.getAttribute('data-anav-extra') || 0);

        const headerSelectors = [
          'sticky-header',
          '#shopify-section-header',
          '.header-wrapper',
          'header.section-header',
          'header'
        ];

        let validPairs = [];
        let scrollTicking = false;
        const stickyWrap = root.closest('.shopify-section') || root;
        const navList = root.querySelector('.anav__list');

        function getHeaderEl() {
          for (const sel of headerSelectors) {
            const el = document.querySelector(sel);
            if (el) return el;
          }
          return null;
        }

        function getHeaderOffset() {
          const el = getHeaderEl();
          if (!el) return 0;

          const cs = window.getComputedStyle(el);
          const pos = cs.position;

          if (pos === 'fixed' || pos === 'sticky') return el.offsetHeight || 0;

          const r = el.getBoundingClientRect();
          if (r.top <= 0 && r.bottom > 0) return Math.round(r.height);

          return 0;
        }

        // Bottom edge of the header as currently visible (0 when the on-scroll-up header is hidden).
        function getVisibleHeaderBottom() {
          const el = getHeaderEl();
          if (!el) return 0;
          return Math.max(0, Math.round(el.getBoundingClientRect().bottom));
        }

        function getNavHeight() {
          return Math.round(root.getBoundingClientRect().height);
        }

        function updateSticky() {
          const headerBottom = getVisibleHeaderBottom();
          stickyWrap.style.setProperty('--anav-top', headerBottom + 'px');
          const stuck = root.getBoundingClientRect().top <= headerBottom + 1 && window.pageYOffset > 0;
          root.classList.toggle('is-stuck', stuck);
        }

        function revealActiveLink(link) {
          if (!navList || navList.scrollWidth <= navList.clientWidth) return;
          const listRect = navList.getBoundingClientRect();
          const linkRect = link.getBoundingClientRect();
          const delta = (linkRect.left + linkRect.width / 2) - (listRect.left + listRect.width / 2);
          navList.scrollTo({ left: navList.scrollLeft + delta, behavior: 'smooth' });
        }

        function tryInjectMissingAnchor(id) {
          if (!id || document.getElementById(id)) return;

          const allSections = Array.from(document.querySelectorAll('main .shopify-section'));
          const navIdx = allSections.findIndex(s => s.contains(root));
          const targetSections = navIdx > -1 ? allSections.slice(navIdx + 1) : allSections;

          targetSections.forEach(section => {
            if (document.getElementById(id)) return;

            if (id === 'bewertungen' && section.querySelector('[class*="review"], [id*="review"], [class*="trusted"], etrusted-widget, .etrusted-widget')) {
              const anchor = document.createElement('div');
              anchor.id = id;
              section.prepend(anchor);
            }
          });
        }

        function getUsefulTargetFromAnchor(anchor) {
          if (!anchor) return null;

          const section = anchor.closest('.shopify-section');
          if (section) return section;

          let next = anchor.nextElementSibling;
          while (next) {
            const rect = next.getBoundingClientRect();
            const text = (next.textContent || '').trim();

            if (rect.height > 24 || text.length > 0 || next.children.length > 0) {
              return next;
            }

            next = next.nextElementSibling;
          }

          return anchor.parentElement || anchor;
        }

        function isTargetVisibleAndMeaningful(el) {
          if (!el) return false;

          const style = window.getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden') return false;

          const rect = el.getBoundingClientRect();
          // innerText ignores CSS/JS source in <style>/<script> tags. Using
          // textContent made empty app sections look populated because their
          // padding styles still contributed text.
          const text = (el.innerText || '').replace(/\s+/g, '').trim();
          const hasVisibleMedia = Array.from(
            el.querySelectorAll('img, picture, video, iframe, canvas, svg, [role="img"], etrusted-widget')
          ).some(node => {
            const nodeStyle = window.getComputedStyle(node);
            const nodeRect = node.getBoundingClientRect();

            return nodeStyle.display !== 'none'
              && nodeStyle.visibility !== 'hidden'
              && nodeRect.width > 1
              && nodeRect.height > 1;
          });

          if (rect.height < 24) return false;
          if (!text.length && !hasVisibleMedia) return false;

          return true;
        }

        function setActiveById(id) {
          validPairs.forEach(entry => {
            const active = entry.id === id;
            entry.link.classList.toggle('is-active', active);

            if (active) {
              if (entry.link.getAttribute('aria-current') !== 'true') revealActiveLink(entry.link);
              entry.link.setAttribute('aria-current', 'true');
            } else entry.link.removeAttribute('aria-current');
          });
        }

        function getScrollTopForId(id) {
          const entry = validPairs.find(item => item.id === id);
          if (!entry || !entry.anchor) return null;

          const rawTop = entry.anchor.getBoundingClientRect().top + window.pageYOffset;
          // The on-scroll-up header hides while scrolling down and shows while scrolling up;
          // the sticky nav is always on screen, so leave room for it in both cases.
          const scrollingDown = rawTop - getNavHeight() > window.pageYOffset;
          const headerSpace = scrollingDown ? 0 : getHeaderOffset();
          const offset = headerSpace + getNavHeight() + extraOffset;

          return Math.max(0, Math.round(rawTop - offset));
        }

        function scrollToTargetId(id) {
          const top = getScrollTopForId(id);
          if (top === null) return;

          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });

          try {
            history.replaceState(null, '', '#' + id);
          } catch (e) {}
        }

        function updateActiveOnScroll() {
          if (!validPairs.length) return;

          const offsetLine = getVisibleHeaderBottom() + getNavHeight() + extraOffset + 40;
          let current = validPairs[0];

          for (let i = 0; i < validPairs.length; i++) {
            const entry = validPairs[i];
            const rect = entry.observeTarget.getBoundingClientRect();

            if (rect.top <= offsetLine) {
              current = entry;
            } else {
              break;
            }
          }

          if (current) setActiveById(current.id);
        }

        let settleTimer = null;
        function onScroll() {
          // The header slides in/out with a CSS transition after the scroll event; re-sync once it settles.
          clearTimeout(settleTimer);
          settleTimer = setTimeout(function () {
            updateSticky();
            setTimeout(updateSticky, 350);
          }, 260);
          if (scrollTicking) return;
          scrollTicking = true;

          requestAnimationFrame(() => {
            updateSticky();
            updateActiveOnScroll();
            scrollTicking = false;
          });
        }

        function bindClicks() {
          validPairs.forEach(entry => {
            if (entry.link.dataset.anavBound === 'true') return;

            entry.link.dataset.anavBound = 'true';
            entry.link.addEventListener('click', (e) => {
              e.preventDefault();
              scrollToTargetId(entry.id);
              setActiveById(entry.id);
            });
          });
        }

        function buildNav() {
          const allItems = Array.from(root.querySelectorAll('[data-anav-item]'));
          validPairs = [];

          if (!allItems.length) {
            root.style.display = 'none';
            return;
          }

          allItems.forEach(item => {
            item.classList.remove('is-hidden');

            const link = item.querySelector('[data-anav-link]');
            if (!link) {
              item.classList.add('is-hidden');
              return;
            }

            const id = (link.getAttribute('data-target') || '').trim();
            if (!id) {
              item.classList.add('is-hidden');
              return;
            }

            if (!document.getElementById(id)) {
              tryInjectMissingAnchor(id);
            }

            const anchor = document.getElementById(id);
            if (!anchor) {
              item.classList.add('is-hidden');
              return;
            }

            const usefulTarget = getUsefulTargetFromAnchor(anchor);
            if (!isTargetVisibleAndMeaningful(usefulTarget)) {
              item.classList.add('is-hidden');
              return;
            }

            validPairs.push({
              item,
              link,
              id,
              anchor,
              observeTarget: usefulTarget
            });
          });

          if (!validPairs.length) {
            root.style.display = 'none';
            return;
          }

          root.style.display = '';
          bindClicks();

          const hash = (window.location.hash || '').replace('#', '');
          const hashed = validPairs.find(entry => entry.id === hash);

          if (hashed) {
            setActiveById(hashed.id);
          } else {
            setActiveById(validPairs[0].id);
          }

          updateActiveOnScroll();
        }

        function init() {
          buildNav();
          setTimeout(buildNav, 120);
          setTimeout(buildNav, 400);
          setTimeout(buildNav, 900);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
          init();
        }

        window.addEventListener('load', init, { passive: true });
        window.addEventListener('resize', buildNav, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        const headerSection = document.querySelector('.section-header') || getHeaderEl();
        if (headerSection) headerSection.addEventListener('transitionend', updateSticky);
        updateSticky();
  }

  function initAll(scope) {
    const context = scope || document;
    if (context.matches && context.matches('[data-anav]')) init(context);
    context.querySelectorAll('[data-anav]').forEach(init);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
